import { Routes } from '@angular/router';

export const LazyAdminRoutes: Routes = [
    {
        path: 'admin',
        // eslint-disable-next-line @typescript-eslint/promise-function-async
        loadChildren: () =>
            import(
                /* webpackChunkName: 'app.admin' */ './admin.module'
                /* webpackPrefetch: true */
            ).then((m) => m.CmpsAdminModule),
    },
];
